import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "block"]

  addFields(event) {
    event.preventDefault()
    const blocks = this.blockTargets
    if (blocks.length === 0) return

    const lastBlock = blocks[blocks.length - 1]
    const oldIndex = lastBlock.dataset.index
    const newIndex = this.nextIndex()

    const clone = lastBlock.cloneNode(true)
    clone.dataset.index = newIndex

    this.renameNestedFields(clone, oldIndex, newIndex)
    this.resetFieldValues(clone)

    const blockNum = blocks.length + 1
    const heading = clone.querySelector("h4")
    if (heading) {
      heading.textContent = heading.textContent.replace(/\d+$/, blockNum)
    }

    this.containerTarget.appendChild(clone)
  }

  nextIndex() {
    const numericIndices = this.blockTargets
      .map((block) => block.dataset.index)
      .filter((index) => /^\d+$/.test(index))
      .map((index) => parseInt(index, 10))

    if (numericIndices.length === 0) return String(Date.now())

    return String(Math.max(...numericIndices) + 1)
  }

  renameNestedFields(root, oldIndex, newIndex) {
    const bracketNeedle = `plan_service_groups_attributes][${oldIndex}]`
    const bracketReplacement = `plan_service_groups_attributes][${newIndex}]`
    const underscoreNeedle = `plan_service_groups_attributes_${oldIndex}_`
    const underscoreReplacement = `plan_service_groups_attributes_${newIndex}_`

    root.querySelectorAll("[name], [id], [for]").forEach((element) => {
      ;["name", "id", "for"].forEach((attribute) => {
        const value = element.getAttribute(attribute)
        if (!value) return

        let updated = value
        if (updated.includes(bracketNeedle)) {
          updated = updated.replaceAll(bracketNeedle, bracketReplacement)
        }
        if (updated.includes(underscoreNeedle)) {
          updated = updated.replaceAll(underscoreNeedle, underscoreReplacement)
        }
        if (updated !== value) element.setAttribute(attribute, updated)
      })
    })
  }

  resetFieldValues(root) {
    root.querySelectorAll('input[type="hidden"][name*="[id]"]').forEach((element) => element.remove())

    root.querySelectorAll("input:not([type=hidden]), textarea, select").forEach((element) => {
      if (element.name?.includes("_destroy")) {
        element.checked = false
      } else {
        element.value = ""
      }
    })
  }
}
